import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { FormattedTime, FormattedMessage } from 'react-intl';
import { LocalizableMessage, LocalizableMessageShape } from 'components/LocalizableMessage/LocalizableMessage';
import { differenceInMinutes } from 'date-fns';
import shiftTimezone from 'tz-offsets';
import { parseUnixSecondsDate } from 'helpers/time';
import { StarRating } from '../StarRating/StarRating';
import { ScheduleCta } from './ScheduleCta';
export var ScheduleRow = function ScheduleRow(_ref) {
  var activities = _ref.activities,
      availableToReserve = _ref.availableToReserve,
      className = _ref.className,
      callToAction = _ref.callToAction,
      creditPrice = _ref.creditPrice,
      creditsReason = _ref.creditsReason,
      endTime = _ref.endTime,
      hideCta = _ref.hideCta,
      itemUrl = _ref.itemUrl,
      label = _ref.label,
      rating = _ref.rating,
      reasonCannotReserve = _ref.reasonCannotReserve,
      schedule = _ref.schedule,
      startTime = _ref.startTime,
      teacherName = _ref.teacherName,
      timezone = _ref.timezone;
  var reason = creditsReason || reasonCannotReserve;
  var parsedStartTime = parseUnixSecondsDate(startTime);
  var parsedEndTime = parseUnixSecondsDate(endTime);
  var durationInMinutes = differenceInMinutes(parsedEndTime, parsedStartTime);
  return React.createElement("div", {
    className: "schedule__row"
  }, React.createElement("div", {
    className: "schedule__row__date"
  }, React.createElement("time", {
    className: "schedule__row__date__time"
  }, React.createElement(FormattedTime, {
    value: new Date(shiftTimezone(startTime, timezone) * 1e3),
    hour12: true,
    hour: "numeric",
    minute: "numeric"
  })), React.createElement("span", {
    className: "schedule__row__date__duration"
  }, React.createElement(FormattedMessage, {
    id: "schedule.row.duration",
    defaultMessage: "{durationInMinutes, number} min",
    values: {
      durationInMinutes: durationInMinutes
    }
  }))), React.createElement("div", {
    className: "schedule__row__classinfo"
  }, React.createElement("strong", null, itemUrl ? React.createElement(Link, {
    to: itemUrl
  }, className) : className), teacherName, !!rating && React.createElement(StarRating, {
    className: "schedule__row__classinfo__rating",
    rating: rating,
    showRatingNumber: true
  })), React.createElement("div", {
    className: "schedule__row__activity"
  }, activities), !hideCta && React.createElement("div", {
    className: "schedule__row__cta"
  }, React.createElement(ScheduleCta, {
    action: callToAction,
    className: "tooltip tooltip--right tooltip--md-center",
    creditPrice: creditPrice,
    schedule: schedule,
    tooltip: !availableToReserve && reason
  }), label && React.createElement("span", {
    className: "schedule__row__label"
  }, label)), reason && React.createElement("div", {
    className: "schedule__row__reason"
  }, React.createElement(LocalizableMessage, {
    message: reason
  })));
};
ScheduleRow.propTypes = {
  activities: PropTypes.string,
  availableToReserve: PropTypes.bool,
  className: PropTypes.string.isRequired,
  callToAction: PropTypes.string.isRequired,
  creditPrice: PropTypes.number,
  creditsReason: PropTypes.string,
  endTime: PropTypes.number.isRequired,
  hideCta: PropTypes.bool,
  itemUrl: PropTypes.string,
  label: PropTypes.string,
  rating: PropTypes.number,
  reasonCannotReserve: LocalizableMessageShape,
  schedule: PropTypes.object,
  startTime: PropTypes.number.isRequired,
  teacherName: PropTypes.string,
  timezone: PropTypes.string.isRequired
};